import axios from "axios";
import { getAuthHeader } from "@/services/user.service.js";

export {
  GetValidations,
  DeleteValidation,
  RunValidation,
  SaveValidation,
  AddValidation,
};

function GetValidations(
  contractNumber,
  versionNumber,
  configurationId,
  onSuccess,
  onError,
) {
  var headers = getAuthHeader();

  axios
    .get(
      process.env.VUE_APP_BASE_API_URL +
        `/contracts/${contractNumber}/versions/${versionNumber}/configurations/${configurationId}/mindestlohn/validations`,
      headers,
    )
    .then((response) => {
      onSuccess(response.data);
    })
    .catch((error) => {
      onError(error);
    });
}

function DeleteValidation(
  contractNumber,
  versionNumber,
  configurationId,
  validationId,
  onSuccess,
  onError,
) {
  var headers = getAuthHeader();

  axios
    .delete(
      process.env.VUE_APP_BASE_API_URL +
        `/contracts/${contractNumber}/versions/${versionNumber}/configurations/${configurationId}/mindestlohn/validations/${validationId}`,
      headers,
    )
    .then(() => {
      onSuccess();
    })
    .catch((error) => {
      onError(error);
    });
}

function RunValidation(
  contractNumber,
  versionNumber,
  configurationId,
  validationId,
  onSuccess,
  onError,
) {
  var headers = getAuthHeader();

  axios
    .get(
      process.env.VUE_APP_BASE_API_URL +
        `/contracts/${contractNumber}/versions/${versionNumber}/configurations/${configurationId}/mindestlohn/validations/results/${validationId}`,
      headers,
    )
    .then((response) => {
      onSuccess(response.data);
    })
    .catch((error) => {
      onError(error);
    });
}

function SaveValidation(
  contractNumber,
  versionNumber,
  configurationId,
  validationObject,
  onSuccess,
  onError,
) {
  var headers = getAuthHeader();

  axios
    .put(
      process.env.VUE_APP_BASE_API_URL +
        `/contracts/${contractNumber}/versions/${versionNumber}/configurations/${configurationId}/mindestlohn/validations/${validationObject.id}`,
      validationObject,
      headers,
    )
    .then((response) => {
      onSuccess(response.data);
    })
    .catch((error) => {
      onError(error);
    });
}

function AddValidation(
  contractNumber,
  versionNumber,
  configurationId,
  validationObject,
  onSuccess,
  onError,
) {
  var headers = getAuthHeader();

  axios
    .post(
      process.env.VUE_APP_BASE_API_URL +
        `/contracts/${contractNumber}/versions/${versionNumber}/configurations/${configurationId}/mindestlohn/validations`,
      validationObject,
      headers,
    )
    .then((response) => {
      onSuccess(response.data);
    })
    .catch((error) => {
      onError(error);
    });
}
